import { CommonFunctions } from '../static/common-functions';
//import { Console } from '@angular/core/src/console';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';
import { RelatedJobBus } from './RelatedJobBus';
import { ConstructionChartDetail } from './ConstructionChartDetail';
import { InvoiceDrawBus } from './InvoiceDrawBus';
import { DispatchNoteBus } from './DispatchNoteBus';

export class CnstCostDetailsBus extends BaseBus {
    CID(): any {
        return null;
    }
    constructor(data: CnstCostDetailsBus) {
        super(data);

        if (CommonFunctions.hasValue(data)) {
            this.detDate = CommonFunctions.getDate(data.detDate);
            this.billPostDate = CommonFunctions.getDate(data.billPostDate);
        }

    }

    initialize(data: CnstCostDetailsBus) {
    super.initialize(data);

    }

    relatedJobType: string;
    costSource: string;
    detDate: Date;
    detName: string;
    detDesc: string;
    qty: number;
    cost: number;
    totalCost: number;
    dayOfWeek: string;
    supplierName: string;
    orderNumber: string;
    billPostDate: Date;
    referenceNumber: string;
    quoteNumber: string;
}
